import {
  MAT_TOOLTIP_DEFAULT_OPTIONS,
  TooltipPosition,
} from '@angular/material/tooltip';

export function makeTooltipProvider(position: TooltipPosition) {
  return {
    provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
    useValue: {
      disableTooltipInteractivity: true,
      position,
    },
  };
}
